import { useContext } from 'react';
import { MetadataFieldContext } from './MetadataFieldContext';
export const useMetadataField = () => useContext(MetadataFieldContext);
